import React from "react";
import { connect } from "react-redux";
import ProgressBar from "react-bootstrap/ProgressBar";

import { fitnessJournalList } from "./helper";

const FitnessJournalCards = ({ data, goal }) => {
	const summaryData =
		fitnessJournalList && data && goal
			? fitnessJournalList.map((item) => {
					const percentage = data[item.id] && goal[item.id] ? (data[item.id] / goal[item.id]) * 100 : 0;

					return { ...item, value: data[item.id], goal: goal[item.id], percentage };
			  })
			: [];

	return (
		<div className="row mt-4 fitness-journal-cards">
			<div className="col-9">
				<div className="row h-100">
					{summaryData &&
						summaryData.map((item, index) => {
							return (
								<div className="col-4" key={index}>
									<div className="card card-primary p-4 border-0  h-100 d-flex justify-content-center">
										<div
											className="journal-card-icon"
											style={{
												backgroundImage: `linear-gradient(to bottom right, ${item.color[0]}, ${
													item.color[1]
												})`,
												boxShadow: `${item.shadow}`
											}}>
											<i className={item.icon} />
										</div>
										<p className="text-uppercase" style={{ color: `${item.text_color}` }}>
											{item.label}
										</p>
										<div className="d-flex align-items-center">
											<h1 className="mr-1" style={{ color: "#6B6A6D" }}>
												{item.value ? item.value : "0"} /
											</h1>
											<h4 style={{ color: "#6B6A6D" }}>
												{item.goal ? item.goal : "0"}
												<span className="unit"> {"" + item.unit}</span>
											</h4>
										</div>
										<div className=" row align-items-center ">
											<div className="col-9">
												<ProgressBar
													className={`w-100 progress-${item.color[1].replace("#", "")}`}
													now={item.percentage}
												/>
											</div>
											<div className="col-3" style={{ whiteSpace: "nowrap" }}>
												{Math.round(item.percentage) > 0 ? "100" : Math.round(item.percentage)} %
											</div>
										</div>
									</div>
								</div>
							);
						})}
				</div>
			</div>
			<div className="col-3 ">
				<div className="card card-primary d-flex justify-content-center align-items-center p-4 border-0 calorie_card">
					<div className="row">
						<div className="col-8">
							<p className="text-uppercase">total calories</p>
							<div className="d-flex align-items-center">
								<h1 className="mr-1" style={{ color: "#fff" }}>
									{data && data.calories_burned ? data.calories_burned : 0} /
								</h1>
								<h4 style={{ color: "#fff" }}> {goal && goal.calories_burned ? goal.calories_burned : 0} </h4>
							</div>
						</div>
						<div className="col-4">
							<div
								className="icon-wrapper mb-2"
								style={{
									backgroundImage: `linear-gradient(to bottom right,#3698C3, #2C91C1)`
								}}>
								<i className="icon icon-calories xl-icon" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(FitnessJournalCards);
